import * as MutationTypes from './mutationTypes';

export const addNotification = ({ commit, state: { notifications, persistentNotifications } }, notification) => {
  // If persistent and not in the queue
  if (notification.persistent && !persistentNotifications.some((savedNotification) => savedNotification.id === notification.id)) {
    commit(MutationTypes.ADD_PERSISTENT_NOTIFICATION, notification);
  } else if (!notification.persistent && !notifications.some((savedNotification) => savedNotification.id === notification.id)) {
    commit(MutationTypes.ADD_NOTIFICATION, notification);
  } else {
    console.warn('Notification already in queue');
  }
};

export const removeNotification = ({ commit }, numNotificationsToRemove) => commit(MutationTypes.REMOVE_NOTIFICATION, numNotificationsToRemove);
export const removeNotificationById = ({ commit }, id) => commit(MutationTypes.REMOVE_PERSISTENT_NOTIFICATION_BY_ID, id);
export const dismissNotifications = ({ commit }) => commit(MutationTypes.DISMISS_NOTIFICATIONS);
export const dismissPersistentNotifications = ({ commit }) => commit(MutationTypes.DISMISS_PERSISTENT_NOTIFICATIONS);
